import { getBlast, isMockMode, simulateDelay } from "../../api";

export const getBlastsForUser = ({ siteId }: { siteId: string }) => {
	if (isMockMode()) {
		const testData = {
			blasts: [
				{
					userCanAdmin: true,
					userCanWrite: true,
					createdDateUtc: "2023-12-05T04:24:04.7631636Z",
					createdBy: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						email: "test.mctestie@mgaol.abc",
						firstName: "Test",
						lastName: "McTestie",
					},
					metadataLastUpdatedUtc: "2023-12-05T04:24:04.7631636Z",
					metadataLastUpdatedBy: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						email: "test.mctestie@mgaol.abc",
						firstName: "Test",
						lastName: "McTestie",
					},
					isPublished: false,
					isDeleted: false,
					dataLastUpdatedUtc: "2023-12-05T04:24:04.7631636Z",
					dataLastUpdatedBy: {
						id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
						email: "test.mctestie@mgaol.abc",
						firstName: "Test",
						lastName: "McTestie",
					},
					updateCount: 0,
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					name: "Test Name",
					siteId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
				},
			],
		};
		return simulateDelay(50, () => testData);
	}

	return getBlast(`blasts/getForUser?siteId=${siteId}`);
};
